import {
  CalendarViewIcon,
  GalleryViewIcon,
  TableIcon,
} from "../../Assets/icons";

export const ViewTypesEnum = {
  TABLE: {
    key: 1,
    value: "table",
    icon: TableIcon,
  },
  GALLERY: {
    key: 2,
    value: "gallery",
    icon: GalleryViewIcon,
  },
  CALENDAR: {
    key: 3,
    value: "calendar",
    icon: CalendarViewIcon,
  },
};
